export default __webpack_public_path__ + "static/media/drum loop sexy.a169ae55.wav";